// extracted by mini-css-extract-plugin
export default {"root":"PettyCashCreatePage_root__XJ+74","body":"PettyCashCreatePage_body__i4trZ"};